import moment from "moment";
import { PAGE_DEFAULT } from "@/utils";
import { DATE_FORMAT_V2_FULL } from "../../components/commons/commonConstant";
import { convertObjectToParams } from "../../components/commons/commons";
import http from "./helpers/httpInterceptor";

const state = () => ({
  requestTypeList: [],
  payrollPeiodList: [],
  locationList: [],
  requestStatusList: [],
  // delegationStatusList: [],
  // abnormalStatusList: [],
  workscheduleList: [],
  reportStatusList: [],
  employeeList: [],
  absentTypesList: [],
  statusList: [],
  reasonTypeList: [],
  departmentList: [],
  memberList: [],
  tableList: [],
  roleList: [],
  reasonRequestList: [],
  projectList: [],
  sameDUStaff: [],
  otTypeList: [],
  checkDateInApprovedPeriod: {},
  lastTimesheet: {},
  remainTypeLeaveList: [],
  listSF4C: [],
  listSDSV: [],
  projectListPermission: [],
  employeeByProject: [],
  otTypeFlexibleList: [],
  absentData: {},
  approverUser: {},
  workScheduleUser: {},
  allProjectList: [],
  reasonList: [],
  pages: PAGE_DEFAULT,
  workScheduleTypeList: [],
  divisionList: [],
  departmentAllList: [],
  departmentByDivisionList: [],
  timeServer: moment(new Date()).format(DATE_FORMAT_V2_FULL),
  selectedRowKeys: [],
  selectedRows: [],
  isSelected: false,
});

// mutations
const mutations = {
  REQUEST_TYPE_DATA_LIST(states, data) {
    states.requestTypeList = data;
  },

  PAYROLL_PERIOD_DATA_LIST(states, data) {
    states.payrollPeiodList = data;
  },

  LOCATION_DATA_LIST(states, data) {
    states.locationList = data;
  },

  REQUEST_STATUS_DATA_LIST(states, data) {
    states.requestStatusList = data;
  },

  // DELEGATION_STATUS_DATA_LIST(states, data) {
  // 	states.delegationStatusList = data
  // },

  // ABNORMAL_STATUS_DATA_LIST(states, data) {
  // 	states.abnormalStatusList = data
  // },

  REPORT_STATUS_DATA_LIST(states, data) {
    states.reportStatusList = data;
  },

  EMPLOYEE_DATA_LIST(states, data) {
    states.employeeList = data.map((item) => {
      return {
        value: item.user_name,
        label: item.name,
        department: item.department_name?.nameEn || "",
        id: item.id,
        sf4c_id: item.sf4c_id,
      };
    });
  },

  EMPLOYEE_DATA_SDSV(states, data) {
    states.listSDSV = data.map((item) => {
      return {
        value: item.attendance_check_id,
        label: item.attendance_check_name,
        id: item.id,
      };
    });
  },

  SAME_DU_STAFF(states, data) {
    states.sameDUStaff = data.map((item) => {
      return {
        value: item.user_name,
        label: item.name,
        department: item.department_name?.nameEn || "",
        id: item.id,
      };
    });
  },

  MEMBER_DATA_LIST(states, data) {
    // states.memberList = data
    states.memberList = data.map((item) => {
      return {
        value: item.user_name,
        label: item.name,
      };
    });
  },

  ABSENT_DATA_LIST(states, data) {
    states.absentTypesList = data;
  },
  STATUS_LIST(states, data) {
    states.statusList = data;
  },
  REASON_TYPE_LIST(states, data) {
    states.reasonTypeList = data;
  },
  DEPARTMENT_LIST(states, data) {
    states.departmentList = data.filter((v, i, a) => a.findIndex((t) => t.department_code === v.department_code) === i);
  },
  LIST_SF4C(states, data) {
    states.listSF4C = data.map((item) => {
      return {
        value: item.sf4c_id,
        label: item.name,
      };
    });
  },
  TABLE_LIST(states, data) {
    states.tableList = data;
  },
  ROLE_LIST(states, data) {
    states.roleList = data;
  },
  REASON_LIST(states, data) {
    states.reasonRequestList = data;
  },
  PROJECT_LIST(states, data) {
    states.projectList = data;
  },
  OT_TYPE(states, data) {
    states.otTypeList = data;
  },
  OT_TYPE_FLEXIBLE(states, data) {
    states.otTypeFlexibleList = data;
  },

  DATE_PERIOD(states, data) {
    states.checkDateInApprovedPeriod = data;
  },
  LAST_TIMESHEET(states, data) {
    states.lastTimesheet = data;
  },
  REMAIN_TYPE_LEAVE_LIST(states, data) {
    states.remainTypeLeaveList = data;
  },
  WORKSCHEDULE_LIST(states, data) {
    states.workscheduleList = data;
  },
  PROJECT_LIST_PERMISSION(states, data) {
    states.projectListPermission = data;
  },
  GET_EMPLOYEE_BY_PROJECT(states, data) {
    states.employeeByProject = data;
  },
  GET_ABSENT_DATA(states, data) {
    states.absentData = data;
  },
  GET_APPROVER_USER(states, data) {
    states.approverUser = data;
  },
  GET_WORK_SCHEDULE_USER(states, data) {
    states.workScheduleUser = data;
  },
  ALL_PROJECT_LIST(states, data) {
    states.allProjectList = data;
  },
  GET_REASON_LIST(states, data) {
    states.reasonList = data;
  },
  SET_PAGES(state, data) {
    state.pages = data ?? PAGE_DEFAULT;
  },
  GET_WORK_SCHEDULE_TYPE_LIST(state, data) {
    state.workScheduleTypeList = data;
  },
  GET_DIVISION_LIST(state, data) {
    state.divisionList = data;
    state.departmentAllList = state.divisionList?.reduce((result, currentDivision) => {
      return result.concat(currentDivision.child);
    }, []);
    state.departmentAllList.sort((a, b) => sortName(a, b));
  },
  GET_DEPARTMENT_BY_DIVISION_LIST(state, data) {
    if (!state.divisionList || !data || data.length <= 0) {
      state.departmentByDivisionList = [];
    }

    state.departmentByDivisionList = state.divisionList.reduce((result, currentDivision) => {
      if (data.includes(currentDivision.department_code)) {
        return result.concat(currentDivision.child);
      }
      return result;
    }, []);
    state.departmentByDivisionList.sort((a, b) => sortName(a, b));
  },
  GET_TIME_SERVER(state, data) {
    state.timeServer = data;
  },
  SET_SELECTED_ROW_KEYS(state, data) {
    state.selectedRowKeys = data;
  },
  SET_SELECTED_ROW(state, { data, from }) {
    state.selectedRows = data;
    state.isSelected = from === "multiply" ? true : false;
  },
  SET_IS_SELECTED(state, data) {
    state.isSelected = data;
  },
  CLEAR_SELECTED(state) {
    state.selectedRowKeys = [];
    state.selectedRows = [];
  },
};
const actions = {
  getListSF4C({ commit }, value) {
    return http
      .get("/tms/filters/get-all-sf4cId?filter=" + value)
      .then((res) => {
        commit("LIST_SF4C", res.data.data);
        return res.data.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  ///Action get Request type
  getListRequestTypeList({ commit }) {
    return http
      .get("/tms/filters/requests")
      .then((res) => {
        commit("REQUEST_TYPE_DATA_LIST", res.data);
        return res.data;
      })
      .catch((error) => {
        throw error;
      });
  },

  ///Action get Payroll period
  getListPayrollPeriodList({ commit }) {
    return http
      .get("/tms/filters/periods")
      .then((res) => {
        commit("PAYROLL_PERIOD_DATA_LIST", res.data.data);
        return res.data;
      })
      .catch((error) => {
        throw error;
      });
  },

  ////Action get location list
  getLocationList({ commit }) {
    return http
      .get("/tms/filters/location")
      .then((res) => {
        commit("LOCATION_DATA_LIST", res.data.data);
        return res.data;
      })
      .catch((error) => {
        throw error;
      });
  },

  ////Action get request status list
  getRequestStatusList({ commit }) {
    return http
      .get("/tms/filters/request-status")
      .then((res) => {
        commit("REQUEST_STATUS_DATA_LIST", res.data);
        return res.data;
      })
      .catch((error) => {
        throw error;
      });
  },

  ////Action get report status list
  getReportStatusList({ commit }) {
    return http
      .get("/tms/filters/report-status")
      .then((res) => {
        commit("REPORT_STATUS_DATA_LIST", res.data);
        return res.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  // Action get work schedule list
  getWorkScheduleList({ commit }) {
    return http
      .get("/tms/employee/get-all-work-schedule")
      .then((res) => {
        commit("WORKSCHEDULE_LIST", res.data);
        return res.data;
      })
      .catch((error) => {
        throw error;
      });
  },

  ////Action get employee list
  getEmployeeList({ commit }, value) {
    return http
      .get("/tms/filters/employee?filter=" + value)
      .then((res) => {
        commit("EMPLOYEE_DATA_LIST", res.data.data);
        let data = [];
        data = res.data.data.map((item) => {
          return {
            value: item.user_name,
            label: item.name,
            department: item.department_name ? item.department_name.nameEn : "",
            id: item.id,
            sf4c_id: item.sf4c_id,
          };
        });
        return data;
      })
      .catch((error) => {
        throw error;
      });
  },
  getEmployeeByProject({ commit }, value) {
    const params = convertObjectToParams(value);
    return http
      .get(`/tms/filters/get-all-employee-by-project${params}`)
      .then((res) => {
        let data = [];
        data = res.data.data.map((item) => {
          return {
            value: item.user_name,
            label: item.name,
            department: item.department_name?.nameEn || null,
            id: item.id,
          };
        });
        commit("GET_EMPLOYEE_BY_PROJECT", data);
        return data;
      })
      .catch((error) => {
        throw error;
      });
  },

  getEmployeeSDSV({ commit }, value) {
    return http
      .get("/tms/filters/employee-soda-mapping?filter=" + value)
      .then((res) => {
        commit("EMPLOYEE_DATA_SDSV", res.data.data);
        return res.data.data;
      })
      .catch((error) => {
        throw error;
      });
  },

  getSameDUStaffList({ commit }, value) {
    return http
      .get("/tms/filters/employee-ot?username=" + value)
      .then((res) => {
        commit("SAME_DU_STAFF", res.data.data);
        let data = [];
        data = res.data.data.map((item) => {
          return {
            value: item.user_name,
            label: item.name,
            department: item.department_name?.nameEn || null,
            id: item.id,
          };
        });
        return data;
      })
      .catch((error) => {
        throw error;
      });
  },

  ////Action get mebmber list
  getMemberList({ commit }) {
    return http
      .get("/tms/filters/get-all-member-for-delegate")
      .then((res) => {
        commit("MEMBER_DATA_LIST", res.data.data);
        return res.data.data;
      })
      .catch((error) => {
        throw error;
      });
  },

  getStatusFlexible({ commit }) {
    return http
      .get("/tms/filters/status-type-flexible")
      .then((res) => {
        commit("STATUS_LIST", res.data.data);
        return res.data.data;
      })
      .catch((error) => {
        throw error;
      });
  },

  ////Action get absent type list
  getAbsentList({ commit }) {
    return http
      .get("/tms/filters/absent")
      .then((res) => {
        commit("ABSENT_DATA_LIST", res.data.data);
        return res.data.data;
      })
      .catch((error) => {
        throw error;
      });
  },

  ////Action get status list
  getStatus({ commit }) {
    return http
      .get("/tms/filters/status")
      .then((res) => {
        commit("STATUS_LIST", res.data.data);
        return res.data.data;
      })
      .catch((error) => {
        throw error;
      });
  },

  ////Action get reason type list
  getReasonTypeList({ commit }) {
    return http
      .get("/tms/filters/reason-types")
      .then((res) => {
        commit("REASON_TYPE_LIST", res.data.data);
        return res.data.data;
      })
      .catch((error) => {
        throw error;
      });
  },

  ////Action get departments list
  getDepartmentList({ commit }) {
    return http
      .get("/tms/filters/department")
      .then((res) => {
        commit("DEPARTMENT_LIST", res.data.data);
        return res.data.data;
      })
      .catch((error) => {
        throw error;
      });
  },

  ////Action get table list
  getTableList({ commit }) {
    return http
      .get("/tms/filters/table")
      .then((res) => {
        commit("TABLE_LIST", res.data.data);
        return res.data.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  getRoleList({ commit }) {
    return http
      .get("/tms/filters/role")
      .then((res) => {
        commit("ROLE_LIST", res.data.data);
      })
      .catch((error) => {
        throw error;
      });
  },
  ////Action get table list
  getReasonRequestList({ commit }) {
    return http
      .get("/tms/settings/work-types")
      .then((res) => {
        commit("REASON_LIST", res.data.data);
        return res.data.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  //Action get project list
  getAllProjectList({ commit }) {
    return http
      .get("tms/filters/projects")
      .then((res) => {
        commit("ALL_PROJECT_LIST", res.data);
        return res.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  getProjectList({ commit }, value) {
    return http
      .get(`tms/filters/get-all-projects?key=${value}`)
      .then((res) => {
        commit("PROJECT_LIST", res.data.data);
        return res.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  //Action get project list permission
  getProjectListPermission({ commit }, payload) {
    return http
      .get(`tms/filters/employee-projects${convertObjectToParams(payload)}`)
      .then((res) => {
        commit("PROJECT_LIST_PERMISSION", res.data.data);
        return res.data.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  getOTTypeList({ commit }) {
    return http
      .get("tms/filters/ot-type")
      .then((res) => {
        commit("OT_TYPE", res.data.data);
        return res.data.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  getOTTypeFlexibleList({ commit }) {
    return http
      .get("tms/filters/ot-type-flexible")
      .then((res) => {
        commit("OT_TYPE_FLEXIBLE", res.data.data);
        return res.data.data;
      })
      .catch((error) => {
        throw error;
      });
  },

  getEndDateOfLastTimsheet({ commit }) {
    return http
      .get("/tms/timesheets/get-end-date-of-last-timesheet")
      .then((res) => {
        commit("LAST_TIMESHEET", res.data);
        return res.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  checkDateInApprovedPeriod({ commit }, payload) {
    return http
      .get("/tms/timesheets/is-date-from-approved-timesheet" + payload)
      .then((res) => {
        commit("DATE_PERIOD", res.data);
        return res.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  getRemainTypeLeave({ commit }) {
    return http
      .get("/tms/employee/leaving-type")
      .then((res) => {
        commit("REMAIN_TYPE_LEAVE_LIST", res.data);
        return res.data;
      })
      .catch((err) => {
        throw err;
      });
  },
  updateLeavingRemain({ commit }, payload) {
    return http
      .put(`/tms/employee/remain-leave/${payload.url}`, payload.data)
      .then((res) => {
        commit("UPDATE_LEAVING_REMAIN_DATA", res.data);
        return res.data;
      })
      .catch((err) => {
        throw err;
      });
  },
  getAbsentData({ commit }, payload) {
    return http
      .get(`/tms/request-management/${payload.userId}/explanation-info/${payload.date}`)
      .then((res) => {
        commit("GET_ABSENT_DATA", res.data.data);
        return res.data.data;
      })
      .catch((err) => {
        throw err;
      });
  },
  getApproverUser({ commit }, payload) {
    return http
      .get(`/tms/filters/get-approver-for-user?username=${payload.userName}&date=${payload.date}`)
      .then((res) => {
        commit("GET_APPROVER_USER", res.data);
        return res.data;
      })
      .catch((err) => {
        throw err;
      });
  },
  getWorkScheduleUser({ commit }, payload) {
    const { userId, date } = payload;
    return http
      .get(`/tms/employee/work-schedule?employeeId=${userId}&date=${date}`)
      .then((res) => {
        commit("GET_WORK_SCHEDULE_USER", res.data.data?.working_time ?? 0);
        return res.data;
      })
      .catch((err) => {
        throw err;
      });
  },
  getWorkScheduleTypeUser({ commit }, payload) {
    const { userId, date, type } = payload;
    return http
      .get(`/tms/employee/work-schedule-type?employeeId=${userId}&date=${date}&type=${type}`)
      .then((res) => {
        commit("GET_WORK_SCHEDULE_USER", res.data.data?.working_time ?? 0);
        return res.data;
      })
      .catch((err) => {
        throw err;
      });
  },
  checkWorkingType(_, payload) {
    const { employeeId, requestDate } = payload;
    return http
      .get(`/tms/employee/check-working-type?employeeId=${employeeId}&requestDate=${requestDate}`)
      .then((res) => {
        return res.data.data;
      })
      .catch((err) => {
        throw err;
      });
  },
  getReasonListByScreen({ commit }, payload) {
    return http
      .get(`/tms/request-management/get-reason-selections?screenType=${payload}`)
      .then((res) => {
        commit("GET_REASON_LIST", res.data.data);
        return res.data;
      })
      .catch((err) => {
        throw err;
      });
  },
  getWorkScheduleTypeList({ commit }) {
    return http
      .get(`/tms/filters/get-all-work-schedule-types`)
      .then((res) => {
        commit("GET_WORK_SCHEDULE_TYPE_LIST", res.data.data);
        return res.data;
      })
      .catch((err) => {
        throw err;
      });
  },
  getDivisionList({ commit }) {
    return http
      .get(`/tms/filters/get-all-divisions-departments`)
      .then((res) => {
        commit("GET_DIVISION_LIST", res.data.data);
        return res.data;
      })
      .catch((err) => {
        throw err;
      });
  },
  getTimeServer({ commit }) {
    return http
      .get(`/tms/filters/get-time`)
      .then((res) => {
        const { dateTimeNow } = res.data.data;
        commit("GET_TIME_SERVER", dateTimeNow);
        return res.data;
      })
      .catch((err) => {
        throw err;
      });
  },
};

const sortName = (a, b) => {
  if (a.name < b.name) {
    return -1;
  } else if (a.name > b.name) {
    return 1;
  }
  return 0;
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
